import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/channels/guest/$channelId/settings` activates the
// channel-settings column (col 3). The Channels layout reads this off the leaf
// match and renders ChannelSettingsDialog (variant="panel") as col 3.
export const Route = createFileRoute("/$orgSlug/$eventSlug/channels/guest/$channelId/settings")({
  component: () => null,
})
